export const ERROR_MESSAGES = {
  wrong_email: "Email address is not correct",
  wrong_password: "Password is not correct.",
  mismatching_email: "You tried to login with wrong email."
};
